import { render, staticRenderFns } from "./KnowledgeContentSelectionView.vue?vue&type=template&id=6af7d2ee&"
import script from "./KnowledgeContentSelectionView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentSelectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports